const currencyOpts = {
  strCode: 'FC',
  bDefault: true,
  dbValue: 1,
  strGroupingSeparator: ',',
  strDecimalSeparator: '.',
  strDisplayFormat: '#,###,###,##0.0',
  bCodeAppendedEnd: false,
  bAddCodeValueSeparator: true,
  strCodeValueSeparator: ' ',
  intFractionsCount: 2,
  bRoundHalfUp: 0,
};

const formatCurrency = (amount, currencyOpts) => {
  const {
    strCode,
    strGroupingSeparator = '',
    strDecimalSeparator = '.',
    bCodeAppendedEnd,
    bAddCodeValueSeparator,
    strCodeValueSeparator = ' ',
    intFractionsCount = 0,
    bRoundHalfUp = 0,
  } = currencyOpts;

  if (!strCode || typeof strCode !== 'string') {
    throw new Error('Invalid currency code');
  }

  if (typeof amount !== 'number' || !Number.isFinite(amount)) {
    throw new Error('Invalid amount');
  }

  const formatAmount = (value) => {
    const places = Math.max(intFractionsCount, 0);
    const factor = 10 ** places;
    const roundedValue = bRoundHalfUp
      ? Number(value.toFixed(places))
      : Math.floor(value * factor) / factor;

    const [integerPart, decimalPart = ''] = roundedValue
      .toFixed(places)
      .split('.');

    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      strGroupingSeparator,
    );

    if (intFractionsCount < 1) {
      return formattedIntegerPart;
    }

    const formattedDecimalPart = decimalPart.padEnd(
      intFractionsCount,
      '0',
    );

    return `${formattedIntegerPart}${strDecimalSeparator}${formattedDecimalPart}`;
  };

  const formattedAmount = formatAmount(amount);
  const separator = bAddCodeValueSeparator
    ? strCodeValueSeparator
    : '';

  if (bCodeAppendedEnd) {
    return `${formattedAmount}${separator}${strCode}`;
  }

  return `${strCode}${separator}${formattedAmount}`;
};

function getDecimalPlacesFromPrecision(precisionConfig) {
  const precision = Math.abs(Number(precisionConfig));

  if (!Number.isFinite(precision) || precision === 0 || precision >= 1) {
    return 0;
  }

  const [coefficient, exponent = 0] = precision
    .toString()
    .toLowerCase()
    .split('e');

  const decimals = coefficient.split('.')[1]?.length ?? 0;

  return Math.max(0, decimals - Number(exponent));
}

function roundingNumber(number, precisionConfig) {
  if (
    !Number.isFinite(number)
    || !Number.isFinite(precisionConfig)
    || precisionConfig === 0
  ) {
    throw new Error('Invalid values');
  }

  const precision = Math.abs(precisionConfig);
  const round = precisionConfig >= 0 ? Math.ceil : Math.floor;

  if (precision < 1) {
    const decimalPlaces = getDecimalPlacesFromPrecision(precision);
    const factor = 10 ** decimalPlaces;
    return round((number + Number.EPSILON) * factor) / factor;
  }

  return round(number / precision) * precision;
}

function formatRoundedNumber(number, precisionConfig) {
  const decimalPlaces = getDecimalPlacesFromPrecision(precisionConfig);

  return roundingNumber(number, precisionConfig)
    .toFixed(decimalPlaces);
}

export {
  formatCurrency, roundingNumber, getDecimalPlacesFromPrecision, formatRoundedNumber, currencyOpts,
};
